import apiClient from "../config/axiosConfig";

/**
 * Elimina un mensaje específico del chat privado
 * Solo el emisor (usuario actual) puede eliminar sus propios mensajes
 * @param {number} mensajeId - ID del mensaje a eliminar
 * @returns {Promise<object>} - Response con confirmación
 */
export const eliminarMensaje = async (mensajeId) => {
  try {
    const response = await apiClient.delete(`/chat-privado/mensaje/${mensajeId}`);
    return { exito: true, data: response.data };
  } catch (error) {
    console.error("Error eliminando mensaje:", error);
    return { exito: false, error: error.response?.status || 500 };
  }
};

/**
 * Limpia toda una conversación (elimina todos los mensajes entre dos usuarios)
 * @param {number} otroUsuarioId - ID del otro usuario en la conversación
 * @returns {Promise<object>} - Response con cantidad de mensajes eliminados
 */
export const limpiarConversacion = async (otroUsuarioId) => {
  try {
    const response = await apiClient.delete(`/chat-privado/conversacion/${otroUsuarioId}`);
    return { exito: true, data: response.data };
  } catch (error) {
    console.error("Error limpiando conversación:", error);
    return { exito: false, error: error.response?.status || 500 };
  }
};
